if (!customElements.get('gn-header-menu')) {
  customElements.define('gn-header-menu', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.details = this.querySelector('[data-gn-header-menu]');
      this.summary = this.details?.querySelector('summary');
      if (!this.details || !this.summary) return;
      this.initialized = true;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.mobile = window.matchMedia('(max-width: 780px)');
      this.summary.setAttribute('aria-expanded', String(this.details.open));
      this.summary.addEventListener('click', event => {
        this.focusOnOpen = !this.details.open && event.detail === 0;
        this.setPosition();
      }, options);
      this.details.addEventListener('toggle', () => this.syncState(), options);
      this.querySelector('[data-menu-close]')?.addEventListener('click', () => this.close(true), options);
      this.querySelector('[data-menu-backdrop]')?.addEventListener('click', () => this.close(true), options);
      this.querySelectorAll('nav a').forEach(link => {
        link.addEventListener('click', () => this.close(false), options);
      });
      document.addEventListener('keydown', event => {
        if (event.key === 'Escape' && this.details.open) {
          event.preventDefault();
          this.close(true);
        }
      }, options);
      document.addEventListener('pointerdown', event => {
        if (this.details.open && !this.contains(event.target)) this.close(false);
      }, options);
      document.addEventListener('focusin', event => {
        if (this.details.open && !this.contains(event.target)) this.close(false);
      }, options);
      window.addEventListener('resize', () => {
        if (!this.mobile.matches) this.close(false);
        else if (this.details.open) this.setPosition();
      }, options);
      window.addEventListener('pageshow', () => this.close(false), options);
      this.syncState();
    }

    disconnectedCallback() {
      this.controller?.abort();
      document.documentElement.classList.remove('gn-header-menu-open');
      this.initialized = false;
    }

    setPosition() {
      const header = this.closest('.gn-header');
      if (header) this.style.setProperty('--gn-menu-top', `${Math.max(0, Math.round(header.getBoundingClientRect().bottom))}px`);
    }

    syncState() {
      const open = this.details.open && this.mobile.matches;
      if (this.details.open && !this.mobile.matches) this.details.open = false;
      this.summary.setAttribute('aria-expanded', String(open));
      this.summary.setAttribute('aria-label', open ? this.summary.dataset.closeLabel : this.summary.dataset.openLabel);
      document.documentElement.classList.toggle('gn-header-menu-open', open);
      if (open) {
        this.setPosition();
        if (this.focusOnOpen) this.querySelector('nav a')?.focus({ preventScroll: true });
      }
      this.focusOnOpen = false;
    }

    close(restoreFocus) {
      const wasOpen = this.details.open;
      this.details.open = false;
      this.syncState();
      if (wasOpen && restoreFocus) this.summary.focus({ preventScroll: true });
    }
  });
}
